import { PluginSlot } from '@openedx/frontend-plugin-framework';

const EditFileAlertsSlot = () => <PluginSlot id="org.openedx.frontend.authoring.edit_file_alerts.v1" />;

export default EditFileAlertsSlot;
